export default __webpack_public_path__ + "static/til-hero-db1af55ab459fb5841a0cefdc26e51f2.svg";